import { cn } from "@newxsystems/shared";
import { StratosCardLink } from "../../../../modules/content/components/StratosCardLink/StratosCardLink";
import { StratosCommonContent } from "../../../../modules/content/components/StratosCommonContent/StratosCommonContent";
import { StratosRichText } from "../../../../modules/content/components/StratosRichText/StratosRichText";
import { StratosSection } from "../../../../modules/content/components/StratosSection/StratosSection";
import type { ITextContentGridBlockProps } from "./TextContentGridBlock.props";

const columns = {
  1: "lg:grid-cols-1",
  2: "lg:grid-cols-2",
  3: "lg:grid-cols-3",
  4: "lg:grid-cols-4",
} as const;
const spans = {
  1: "lg:col-span-1",
  2: "lg:col-span-2",
  3: "lg:col-span-3",
  4: "lg:col-span-4",
} as const;

const surfaces = ["bg-mist", "bg-cloud-white", "bg-sunlit"] as const;

export const TextContentGridBlock = ({
  alignment,
  anchorId,
  buttons,
  columnCount,
  description,
  eyebrow,
  heading,
  items,
  parentClass,
  spacing,
}: ITextContentGridBlockProps) => {
  if (!items?.length) return null;

  return (
    <StratosSection className={parentClass} id={anchorId} spacing={spacing}>
      <div className="flex flex-col gap-10 md:gap-14">
        <StratosCommonContent
          alignment={alignment}
          buttons={buttons}
          description={description}
          eyebrow={eyebrow}
          heading={heading}
        />
        <div className={cn("grid grid-cols-1 gap-3 sm:grid-cols-2", columns[columnCount || 3])}>
          {items.map((item, index) => (
            <StratosCardLink
              className={cn(
                "flex min-h-64 flex-col justify-start rounded-[20px] border border-horizon-blue/50 p-7 md:p-9",
                surfaces[index % surfaces.length],
                spans[item.columnSpan || 1],
              )}
              key={index}
              link={item.cardLink}
            >
              <h3 className="max-w-[15ch] font-stratos-display text-3xl font-bold leading-[0.95] tracking-[-0.03em] text-foreground">
                {item.heading}
              </h3>
              {item.description ? (
                <StratosRichText
                  className="mt-4 text-base text-steel md:text-lg"
                  content={item.description}
                />
              ) : null}
            </StratosCardLink>
          ))}
        </div>
      </div>
    </StratosSection>
  );
};

TextContentGridBlock.displayName = "Block::TextContentGridBlock";
